export default __webpack_public_path__ + "static/media/slide_3.74526b63.jpg";